import clsx from 'clsx'
import Image from 'next/image'

/* styling */
import styles from './_.module.css'

interface Props {
  title: string
  description: string
  image?: StrapiImageFile
}

function ConversionFunnel({ title, description, image }: Props): JSX.Element {
  return (
    <section className="bg-blue-web-90 text-white">
      <div className="container | py-10 md:py-18">
        <div className="md:text-center max-w-col-10 | mx-auto px-3 mb-12">
          <h2
            className={clsx(
              'font-heading text-3xl md:text-6xl font-medium | mb-7 md:mb-10',
              styles.title
            )}
            dangerouslySetInnerHTML={{ __html: title }}
          />
          <span
            className="text-base md:text-2xl"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
        {image && (
          <Image
            src={image.url}
            alt={image.alternativeText ?? ''}
            width={image.width}
            height={image.height}
            className="mx-auto"
          />
        )}
      </div>
    </section>
  )
}

export default ConversionFunnel
